import { ChangeDetectionStrategy, Component, inject, output } from '@angular/core';
import { environment } from '@libs/environment';
import { TranslateModule } from '@ngx-translate/core';
import { RouterModule } from '@angular/router';
import { ClarityHelper } from '@libs/helpers/clarity.helper';
import { DATA_LAYER } from '@libs/shared/injections/window';

@Component({
  selector: 'app-header-buttons',
  templateUrl: `./templates/${environment.name}/page.html`,
  styleUrls: [`./templates/${environment.name}/style.sass`],
  standalone: true,
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [TranslateModule, RouterModule]
})
export class HeaderButtonsComponent {
  public readonly onNavigateEvent = output<void>();
  private clarityHelper = inject(ClarityHelper);
  private dataLayer = inject(DATA_LAYER);

  public onNavigate(): void {
    this.onNavigateEvent.emit();
    this.clarityHelper.initClickLoginButtonEvent();
    this.dataLayer.push({
      event: 'click_auth_button',
      text: 'Увійти',
    });
  }
}
